import React, { type PropsWithChildren, createContext, useContext } from 'react';
import { type User } from '../../models/types';
import { notImplemented } from '../../helpers/contextHelpers';

export enum TokenState {
    Valid = 'Valid',
    Invalid = 'Invalid',
    RequiresInteraction = 'RequiresInteraction',
}

export type IAuthService = {
    login: () => void;
    logout: () => void;
    getAccessToken: () => Promise<string | undefined>;
    getSalesforceToken?: () => Promise<string | undefined>;
    user?: User;
    tokenState?: TokenState;
    isAuthenticated?: boolean;
    isLoggingIn?: boolean;
    isStartingUp?: boolean;
    isLoggingOut?: boolean;
};

const defaultAuthService: IAuthService = {
    login: notImplemented,
    logout: notImplemented,
    getAccessToken: notImplemented,
    getSalesforceToken: notImplemented,
    user: undefined,
    tokenState: TokenState.Valid,
    isLoggingIn: false,
    isStartingUp: false,
    isLoggingOut: false
};

export const AuthContext = createContext<IAuthService>(defaultAuthService);

const AuthProvider: React.FC<PropsWithChildren<{ service: IAuthService; }>> = ({ children, service }) => {
    return <AuthContext.Provider
        value={{
            login: service.login,
            logout: service.logout,
            getAccessToken: service.getAccessToken,
            getSalesforceToken: service.getSalesforceToken,
            user: service.user,
            tokenState: service.tokenState,
            isAuthenticated: service.isAuthenticated,
            isLoggingIn: service.isLoggingIn,
            isStartingUp: service.isStartingUp,
            isLoggingOut: service.isLoggingOut
        }}
    >
        {children}
    </AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;

